import { useTranslation } from 'react-i18next'

import { FileIcon } from '@phosphor-icons/react'

import { Alert, Text } from '@reveni-io/reveni-ui'

import ImportFileUploader from '@/common/components/ImportFileUploader/ImportFileUploader'

import { inventoryAcceptedFormats } from './constants'

const ImportInventorySection = ({ onSelectFile, inventoryFile, onDeleteFile, inventoryError, onError }) => {
  const { t } = useTranslation()

  return (
    <>
      <Text type="titleS">{t('Importar archivo')}</Text>
      <ImportFileUploader
        onSelectFile={onSelectFile}
        file={inventoryFile}
        onDeleteFile={onDeleteFile}
        onError={onError}
        placeholder="Arrastra aquí tu archivo CSV o Excel"
        buttonText="haz clic para seleccionarlo desde tu ordenador"
        helperText="Solo formatos CSV o Excel (.csv, .xlsx). Máximo {{maxSizeInMB}}MB por archivo."
        acceptedFormats={inventoryAcceptedFormats}
        invalidFormatText="El archivo debe ser de formato CSV o Excel (.csv, .xlsx)."
        Icon={FileIcon}
      />
      {inventoryError && <Alert type="error">{t(inventoryError)}</Alert>}
    </>
  )
}

export default ImportInventorySection
